<template>
  <div v-if="analyzing || alerts.length > 0" data-test="upload-approval-alerts">
    <ExtractionStatus v-if="analyzing" extracting :extracting-label="t('analyzing')" />
    <InvoiceQuotationAlerts v-else :alerts="alerts" />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import { ExtractionStatus, toCamelCase } from "@estaly/ui";
import InvoiceQuotationAlerts from "@/components/claim/details/invoice/InvoiceQuotationAlerts.vue";

// Alertes IA d'un devis ou d'une facture déposé depuis le BO : le dépôt vaut approbation,
// l'analyse est donc lancée dès le choix du fichier, avant l'envoi.
export default {
  name: "UploadApprovalAlerts",

  components: { ExtractionStatus, InvoiceQuotationAlerts },

  props: {
    file: {
      type: [File, Object],
      default: null,
    },
    // "invoice" ou "quotation"
    documentKind: {
      type: String,
      required: true,
    },
  },

  emits: ["update:analyzing"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      alerts: [],
      analyzing: false,
      analysisToken: 0,
    };
  },

  watch: {
    async file(newFile) {
      const token = ++this.analysisToken;
      this.alerts = [];
      if (!newFile) return this.setAnalyzing(false);

      this.setAnalyzing(true);
      try {
        const response = await this.analyzeDocumentForApproval({ file: newFile, documentKind: this.documentKind });
        if (token !== this.analysisToken) return;
        this.alerts = toCamelCase(response?.data?.alerts || []);
      } catch {
        // Une analyse en échec ne bloque jamais le dépôt.
      } finally {
        if (token === this.analysisToken) this.setAnalyzing(false);
      }
    },
  },

  // Le composant peut disparaître en cours d'analyse : le parent ne doit pas rester bloqué.
  beforeUnmount() {
    this.$emit("update:analyzing", false);
  },

  methods: {
    ...mapActions("claims", ["analyzeDocumentForApproval"]),

    setAnalyzing(analyzing) {
      this.analyzing = analyzing;
      this.$emit("update:analyzing", analyzing);
    },
  },
};
</script>

<i18n src="./UploadApprovalAlerts.i18n.json"></i18n>
